var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_1994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 22.5L44.6625 0L0 22.5V28.125H5.625V90H16.875V39.375H73.125V90H84.375V28.125H90V22.5ZM22.5 33.75V28.125H33.75V33.75H22.5ZM39.375 33.75V28.125H50.625V33.75H39.375ZM56.25 33.75V28.125H67.5V33.75H56.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 50.625H28.125V45H22.5V61.875H39.375V45H33.75V50.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 73.125H28.125V67.5H22.5V84.375H39.375V67.5H33.75V73.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25 73.125H50.625V67.5H45V84.375H61.875V67.5H56.25V73.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_1994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehousing);
export default __webpack_public_path__ + "static/media/warehousing.58c7063fbebdf80010c336e5cdd8a82d.svg";
export { ForwardRef as ReactComponent };